export default {
  preview: '预览',
  move: '移动图片',
  rect: '矩形',
  point: '描点',
  polygon: '多边形',
  polyline: '折线',
  bezier: '曲线区域',
  bezierline: '曲线',
  magicmode: '魔法',
  unmagic: '反魔法',
  complete: '完成',
  delete: '删除',
  recall: '撤销',
  recall2: '反撤销',
  clear: '清空标注',
  reset: '重置图片',
  filstyNor: '标注颜色',
  filstySP: '选中颜色-线',
  filstySPs: '选中颜色-点',
  pointradius: '标注点大小',
  linewidth: '标注线宽',
  alpha: '透明度',
  please: '请输入内容',
  workbanch: '工作台',
  radio: '单选题',
  checkbox: '多选题',
  input: '填空题',
  noChoice: '未选择',
  noNull: '为空',
  lengthErr: '长度错误',
  errorMessage: '请检查所有标注是否都已完成',
  fitbezier: '拟合曲线',
  fitpoly: '拟合折线',
  selpoint: '选中点',
  selset: '选中集',
  numsize: '标注序号大小',
  pointset: '点集',
  transparency: '透明度',
  Threshold: '阈值',
  movedown: '下移',
  moveup: '上移',
  mask: '掩膜',
  deletePoint: '删点',
  reset2: '重置',
  clear2: '清空',
  tool01: '不合格理由'
}



// WEBPACK FOOTER //
// ./src/lang/zh/public/labelTool.js